import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import apiClient from './apiClient';

const pushNotificationKeys = {
  all: ['push-notifications'],
  send: () => [...pushNotificationKeys.all, 'send'],
  dashboard: (filters) => [...pushNotificationKeys.all, 'dashboard', filters],
  markRead: () => [...pushNotificationKeys.all, 'mark-read'],
};

export const useSendPushNotification = () => {
  return useMutation({
    mutationKey: pushNotificationKeys.send(),
    mutationFn: async (payload) => {
      const response = await apiClient.post('push-notifications/send', payload);
      return response.data;
    },
  });
};

const sanitizeDashboardFilters = (filters = {}) => {
  const cleanFilters = { ...filters };

  Object.keys(cleanFilters).forEach((key) => {
    const value = cleanFilters[key];
    if (value === '' || value === null || value === undefined) {
      delete cleanFilters[key];
    }
  });

  return cleanFilters;
};

export const useMobilePushNotificationsDashboard = (filters = {}) => {
  return useQuery({
    queryKey: pushNotificationKeys.dashboard(filters),
    queryFn: async () => {
      const cleanFilters = sanitizeDashboardFilters(filters);
      const response = await apiClient.get('push-notifications/dashboard', {
        params: cleanFilters,
      });
      return response.data;
    },
    keepPreviousData: true,
    staleTime: 60 * 1000,
  });
};

export const useMarkPushNotificationAsRead = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: pushNotificationKeys.markRead(),
    mutationFn: async ({ uuid }) => {
      if (!uuid) {
        throw new Error('UUID requerido para marcar como leída');
      }
      const response = await apiClient.patch(`push-notifications/${uuid}/read`);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: pushNotificationKeys.all });
    },
  });
};

export default useSendPushNotification;
